import { format } from 'date-fns/fp';
import { dateFormat } from '../../domains/reports/adapters/date';

export const formatLocale = format(dateFormat(navigator.language));
